<template>
  <div>
    <div class="mb-2 d-flex align-items-center justify-content-center">
      <div class="w-100">
        <h3 class="mb-1 text-center">
          {{ $t("affiliate_program.title_referral_url") }}
        </h3>
        <div class="w-100">
          <div class="input-group affiliate-link-copy w-100">
            <input
              v-model="affiliateLink"
              type="text"
              class="search-product form-control"
              style="height: 38px"
              disabled
            />
            <div class="input-group-append">
              <div
                id="affiliate-link-copy"
                class="input-group-text"
                style="height: 38px; cursor: pointer"
                @click="copyAffiliateLink"
              >
                <CopyToClipboard
                  :text="affiliateLink"
                  @copy="copyAffiliateLink"
                >
                  <feather-icon icon="CopyIcon" size="14" />
                </CopyToClipboard>
              </div>
              <b-tooltip target="affiliate-link-copy">{{
                copyToClipboard
              }}</b-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center mb-2">
      <div class="d-flex align-items-center bg-white p-1">
        <div class="iconColor">
          <feather-icon icon="DollarSignIcon" size="20" />
        </div>
        <span class="pl-1 pr-1 text-heading">{{ $t("earnings") }}</span>
        <div v-if="isLoading" class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else class="text-amount"
          >$ {{ getResponseData.amount.toFixed(2) || "0" }}</span
        >
      </div>
      <div class="d-flex align-items-center bg-white p-1 ml-2">
        <div class="iconColor">
          <feather-icon icon="PercentIcon" size="20" />
        </div>
        <span class="pl-1 pr-1 text-heading">{{ $t("my_percentage") }}</span>
        <div v-if="isLoading" class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else class="text-amount"
          >{{ getResponseData.affiliatePercentage.toFixed(2) || "0" }} %</span
        >
      </div>
    </div>
    <div>
      <h2 class="mb-1 text-center">
        {{ $t("affiliate_program.title_reffered_friends") }}
      </h2>
      <b-card>
        <b-table
          :fields="fields"
          :items="items"
          responsive
          class="mb-0"
          show-empty
          :empty-text="$t(`affiliate_program.no_record`)"
          empty-filtered-text
        >
          <template>
            <div class="d-flex align-items-center justify-content-center">
              <div class="mb-1 start-chat-icon">
                <feather-icon icon="FolderIcon" size="40" />
              </div>
              <h5 class="sidebar-toggle start-chat-text">
                {{ $t("affiliate_program.no_record") }}
              </h5>
            </div>
          </template>

          <!-- User Column -->
          <template #head(user)>
            {{ $t("affiliate_program.user") }}
          </template>

          <template #cell(user)="data">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center">
                <div
                  style="
                    margin-right: 8px;
                    border-radius: 50%;
                    background-color: #7367f0;
                    color: white;
                    min-width: 32px;
                    min-height: 28px;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <span
                    >{{ data.item.user.firstName.substr(0, 1).toUpperCase()
                    }}{{
                      data.item.user.lastName.substr(0, 1).toUpperCase()
                    }}</span
                  >
                </div>
              </div>
              <div>
                <h5 style="color: #0a64bc">
                  {{ data.item.user.firstName }} {{ data.item.user.lastName }}
                </h5>
                <p style="margin-bottom: 0px">
                  {{ data.item.user.email }}
                </p>
              </div>
            </div>
          </template>

          <!-- User Column -->
          <template #head(subscribedToDate)>
            {{ $t("affiliate_program.subscribed_to_date") }}
          </template>

          <!-- Active Column -->
          <template #head(active)>
            {{ $t("affiliate_program.Paid_for_current_month") }}
          </template>

          <template #cell(active)="data">
            <div>
              <b-badge
                pill
                :variant="`${
                  data.item.active ? 'light-success' : 'light-warning'
                }`"
                class="text-capitalize"
              >
                {{
                  data.item.active
                    ? $t("affiliate_program.yes")
                    : $t("affiliate_program.no")
                }}
              </b-badge>
            </div>
          </template>

          <!-- registrationDate Column -->
          <template #head(registrationDate)>
            {{ $t("affiliate_program.registration_date") }}
          </template>

          <!-- registrationDate Column -->
          <template #head(payed)>
            {{ $t("affiliate_program.payed") }}
          </template>

          <!-- registrationDate Column -->
          <template #cell(payed)="data">
            <div>
              <b-badge
                pill
                :variant="`${
                  data.item.payed ? 'light-success' : 'light-warning'
                }`"
                class="text-capitalize"
              >
                {{
                  data.item.payed
                    ? $t("affiliate_program.payment_success")
                    : $t("affiliate_program.payment_unsuccess")
                }}
              </b-badge>
            </div>
          </template>
        </b-table>
        <b-row class="text-center mb-2">
          <b-col cols="12">
            <b-spinner v-if="loadMore" large variant="primary" />
            <div v-else style="height: 35px" />
            <div ref="loadMoreObserver" />
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>
<script>
import {
  BTable,
  BTooltip,
  BCard,
  BBadge,
  BSpinner,
  BRow,
  BCol,
} from "bootstrap-vue";

import axios from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CopyToClipboard from "vue-copy-to-clipboard";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BCard,
    BTable,
    BTooltip,
    BBadge,
    BSpinner,
    BRow,
    BCol,
    CopyToClipboard,
  },

  data() {
    return {
      copyToClipboard: "Copy to clipboard",
      direction: "asc",
      sortField: "firstName",
      sortBy: "firstName",
      sortDesc: false,
      fields: [
        {
          key: "user",
          label: "Refferal Info",
          sortable: true,
        },
        {
          key: "subscribedToDate",
          label: "Subscribed To Date",
          sortable: true,
        },
        {
          key: "active",
          label: "Payment Status",
          sortable: true,
        },
        {
          key: "registrationDate",
          label: "registrationDate",
          sortable: true,
        },
        {
          key: "payed",
          label: "Payed",
          sortable: true,
        },
      ],
      items: [],
      affiliateLink: "",
      loadMore: false,
      currentPage: 0,
      getResponseData: null,
      isLoading: false,
    };
  },
  created() {
    this.getAffiliateLink();
    this.getAffiliateAmount();
  },
  mounted() {
    this.observeScroll();
  },
  methods: {
    async getAffiliateAmount() {
      this.isLoading = true;
      try {
        const token = useJwt.getToken();
        const response = await useJwt.AffiliateAmount(token);
        if (response.data) {
          this.isLoading = false;
          this.getResponseData = response?.data;
        }
      } catch (error) {
        this.options = [];
        this.isLoading = false;
        this.getResponseData = {
          amount: 0,
          affiliatePercentage: 0,
        };
        console.error("Error fetching cities:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: errorMessage,
            icon: "DeleteIcon",
            variant: "danger",
          },
        });
      }
    },
    //
    async getAffiliateLink() {
      try {
        const data = await axios.get(
          `/account/api/affiliate/get-my-affiliate-url`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "Access-Control-Allow-Credentials": true,
              "Access-Control-Allow-Origin": "https://coherent-accounting.com",
            },
          }
        );

        if (data && data.data && data.data.affiliateUrl) {
          this.affiliateLink = data.data.affiliateUrl;
        } else {
          this.affiliateLink = "";
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Affiliate Link Fetched Error",
            icon: "DeleteIcon",
            variant: "danger",
          },
        });
      }
    },
    // getting the list of all affiliates
    async getAllAffiliates() {
      axios
        .get(
          `/account/api/affiliate/get-user-affiliates/${this.currentPage}/10`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "Access-Control-Allow-Credentials": true,
              "Access-Control-Allow-Origin": "https://coherent-accounting.com",
            },
          }
        )
        .then((response) => {
          if (response && response.data && response.data.elements) {
            const affilates = response.data.elements.map((affilate) => ({
              user: {
                email: affilate.email,
                firstName: affilate.firstName,
                lastName: affilate.lastName,
              },
              ...affilate,
            }));

            if (this.items.length) {
              this.items.push(...affilates);
            } else {
              this.items = affilates;
            }
          } else {
            this.items = [];
          }

          this.loadMore = false;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching affiliates",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    // Scroll to bottom to fetch affiliates
    observeScroll() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      };
      const observer = new IntersectionObserver(async (entries) => {
        this.loadMore = true;
        if (entries[0].isIntersecting) {
          this.currentPage += 1;
          this.getAllAffiliates();
        }
      }, options);
      observer.observe(this.$refs.loadMoreObserver);
    },
    // Show toast when copy affiliate link clicked
    copyAffiliateLink() {
      this.$root.$emit("bv::hide::tooltip");
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Affiliate Link Copy",
          icon: "DeleteIcon",
          variant: "success",
        },
      });
    },
  },
};
</script>
<style lang="scss">
/*  */
.input-group {
  box-shadow: none !important;
}
.affiliate-link-copy {
  input.form-control:disabled {
    text-align: left;
    background-color: #fff;
  }

  max-width: 600px;
  margin: 0 auto;
}
.dark-layout {
  .affiliate-link-copy {
    input.form-control:disabled {
      background-color: #283046;
    }
  }
}

.iconColor {
  background-color: rgb(215, 213, 243);
  color: rgb(115, 103, 240);
  padding: 8px;
  border-radius: 8px;
}

.text-amount {
  font-size: 22px;
  font-weight: 600;
}

.text-heading {
  font-size: 18px;
  font-weight: 500;
}
</style>
